import React from "react";
import Apollo from "./Apollo";
import { AppErrorBoundary } from "./AppErrorBoundary";
import IntlProviderWrapper from "./Intl";
import { OuterErrorFallback } from "./OuterErrorFallback";
import QueryProvider from "./QueryProvider";
import Router from "./Router";
import Snackbar from "./Snackbar";
import Theme from "./Theme";

const Root: React.FC = () => {
  return (
    <AppErrorBoundary fallback={OuterErrorFallback}>
      <IntlProviderWrapper>
        <Theme>
          <Snackbar>
            <QueryProvider>
              <Apollo>
                <Router />
              </Apollo>
            </QueryProvider>
          </Snackbar>
        </Theme>
      </IntlProviderWrapper>
    </AppErrorBoundary>
  );
};

export default Root;
